import React, { createContext, useState } from "react";

export const SearchCurrentCustomerContext = createContext({});

export const initialSearchValues = {
  currentCustomerId: "",
  factoryName: "",
  typeOfEstate: [],
  customerGroupByEstateType: [],
  yearOfBudget: [],
  monthOfBudget: [],
  customerGroupByAge: [],
  customerGroupByRegion: [],
  waterConsumptionMin: "",
  waterConsumptionMax: "",
  areaSizeByRaiMin: "",
  areaSizeByRaiMax: "",
  areaSizeByNganMin: "",
  areaSizeByNganMax: "",
  areaSizeByWaMin: "",
  areaSizeByWaMax: "",
  areaSizeByMetersMin: "",
  areaSizeByMetersMax: "",
  buyOrRentLand: "",
  productAndServiceWant: "",
  supportWant: "",
  transactionWant: "",
  crmExpected: "",
  lineOfWorkId: [],
  countryId: [],
  estateId: ""
};

export const initialPageValues = {
  page: 0,
  pageSize: 10,
  total: 0,
  totalPage: 0,
  // sortBy: "currentCustomerId",
  sortBy: "createDate",
  sortDirection: "DESC",
};

const SearchCustomerCurrentProvider = ({ children }) => {
  const [searchValues, setSearchValues] = useState(initialSearchValues);
  const [pageValues, setPageValues] = useState(initialPageValues);
  const [search, setSearch] = useState(true);

  return (
    <SearchCurrentCustomerContext.Provider
      value={{
        searchValues,
        setSearchValues,
        pageValues,
        setPageValues,
        search,
        setSearch,
      }}
    >
      {children}
    </SearchCurrentCustomerContext.Provider>
  );
};

export default SearchCustomerCurrentProvider;
